var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-y custom-scrollbar"},[_c('ion-row',[_c('ion-col',{attrs:{"size":"12","size-lg":"6","offset-lg":"3"}},[_c('div',{staticClass:"padding text-center"},[_c('h1',{staticClass:"h1"},[_vm._v("Błąd 404")]),_c('p',[_vm._v("Strona o podanym adresie nie istnieje.")])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }